(function () {
    'use strict';

    function workflow($rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/workflow.html',
            scope: {
                workflowData: '=',
                currentPhaseIndex: '='
            },
            link: function (scope) {
            }
        };
    }

    workflow.$inject = ['$rootScope'];

    angular.module('ecap.workflow').directive('workflow', workflow);
})();
